if (document.querySelector('.seal-subscription-page') != null) {
  var createAccountLink = document.createElement('a');
  var createAccountText = document.createTextNode('Order History');
  setAttributes(createAccountLink, { "href": "/account", "class": "seal-account-custom-logout" });
  createAccountLink.appendChild(createAccountText);

  var createLogoutLink = document.createElement('a');
  var createLogoutText = document.createTextNode('Log out');
  setAttributes(createLogoutLink, { "href": "/account/logout", "class": "seal-account-custom-logout" });
  createLogoutLink.appendChild(createLogoutText);

  var paymentMethodText = document.createElement('div');
  paymentMethodText.innerHTML= '<h3>Update Payment Method</h3> <span>- please scroll down.</span> <p>If you need help with your subscription please email <a href="mailto:support@yahava.com.au">support@yahava.com.au</a> with your request.</p>'
  setAttributes(paymentMethodText, { "class": "seal-account-custom-payment-method-text" });

  setTimeout(function(){
    document.querySelector('.seal-sectioned').appendChild(createAccountLink); 
    document.querySelector('.seal-sectioned').appendChild(createLogoutLink); 
    document.querySelector('div[data-subscription-status] .seal-sectioned').appendChild(paymentMethodText); 
  },2000 );

  function setAttributes(el, attrs) {
    for(var key in attrs) {
      el.setAttribute(key, attrs[key]);
    }
  }
}
